import { centralizedAuth } from '@cimpress/simple-auth-wrapper';
import { authClientId } from './settings';

const auth = new centralizedAuth({ // eslint-disable-line new-cap
    clientID: authClientId,
    redirectRoute: '/',
});

function setReauthenticationTimer() {
    const expirationTime = (auth.getProfile().exp * 1000) - Date.now();

    window.setTimeout(() => {
        auth.logout(window.location.pathname + window.location.search);
    }, expirationTime);
}

function initializeAuth() {
    return auth.ensureAuthentication(window.location.pathname + window.location.search)
        .then((isAuthenticated) => {
            if (isAuthenticated) {
                setReauthenticationTimer();
            }
        })
        .catch(error => console.error(error)); // eslint-disable-line no-console
}

export default Object.assign({}, auth, { initializeAuth });



// WEBPACK FOOTER //
// ./src/auth.js